<template>
  <div class="actions-cell">
    <button
      class="button small ghost"
      @click.stop="action.clickAction(object)"
      :key="`action_button_${i}`"
      v-for="(action, i) in actions"
    >
      <span class="uppercase">{{ action.label }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "ActionsCell",
  props: {
    object: Object,
    actions: Array
  }
};
</script>

<style lang="scss" scoped>
.actions-cell {
  .button {
    & + .button {
      @apply ml-2;
    }
  }
}

.collapsible-scope-item,
.contract-work-orders-table-view {
  .bdg-table {
    .body {
      .body-row {
        .table-cell {
          .actions-cell {
            .button {
              & + .button {
                @screen md {
                  @apply ml-0 mt-2;
                }

                @media (min-width: 1740px) {
                  @apply ml-2 mt-0;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
